<template>
  <div>
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="true"
      :title="$t('changepwd.interceptionAlert')"
      :visible.sync="tipDialog"
      top="10vh"
      width="600px"
    >
      <div class="problemInterceptPromptMap">
        <div v-for="(key, value) in problemInterceptPromptMap" :key="value">
          <div class="packageReturn">{{ value }}</div>
          <div v-for="(itemKey, indexKey) in key" :key="indexKey" class="packageReturnItem">
            {{ itemKey }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'TipDialog',
  props: {
    problemInterceptPromptMap: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tipDialog: false
    };
  },
  created() {},
  methods: {
    // 处理弹框显示
    handleTipDialog() {
      this.tipDialog = true;
    }
  }
};
</script>

<style scoped>
.packageReturn {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
}

.packageReturnItem {
  margin-bottom: 5px;
  font-size: 16px;
}
</style>
